import { useContext, useState } from "react";
import SellLong from "./sellLong";
import { UserContext } from "../../context/provider";
import SellLongCalculator from "../mostlyUsed/sellLongCalculator";
import axios from "axios";
import { dummyLongData } from "./test";
import { exportToCSV, ManyFileInput } from "../mostlyUsed/mainComponents";

const DistributionList = () => {
  const [proccessState, setProccessState] = useState(0);
  const [proccessText, setProccessText] = useState("");
  const [fileDatas, setFileDatas] = useState([]);
  const { verifiedCodes } = useContext(UserContext);
  let sellLong = [];
  let finalData = [];
  let kargah = []

  const gradeLimit = 10;
  const minProductionQuantity = 20;

  const groups = {
    kids: {
      from: 25,
      to: 29,
      factor: {
        25: 1,
        26: 1,
        27: 1,
        28: 1,
        29: 1,
      },
      fillOrder: [25, 26, 27, 28, 29, 25, 26, 27, 28, 29, 25, 26, 27, 28, 29],
      minProduction: { 1: 6, 2: 12 },
    },
    child: {
      from: 30,
      to: 34,
      factor: {
        30: 1,
        31: 1,
        32: 1,
        33: 1,
        34: 1,
      },
      fillOrder: [
        30, 31, 32, 33, 34, 30, 31, 32, 33, 34, 30, 31, 32, 33, 34, 30, 31, 32,
        33, 34,
      ],
      minProduction: { 1: 5, 2: 11 },
    },
    female: {
      from: 35,
      to: 40,
      factor: {
        35: 1,
        36: 2,
        37: 2,
        38: 3,
        39: 2,
        40: 2,
      },
      fillOrder: [38, 37, 39, 36, 40, 38, 37, 39, 35, 36, 40],
      minProduction: { 1: 12, 2: 18 },
    },
    male: {
      from: 41,
      to: 46,
      factor: {
        41: 2,
        42: 2,
        43: 1,
        44: 1,
        45: 1,
        46: 1,
      },
      fillOrder: [41, 42, 43, 44, 45, 41, 42, 43, 44, 45, 41, 42, 43, 41, 42],
      minProduction: { 1: 6, 2: 12 },
    },
  };
  // const groups = {
  //   kids: {
  //     from: 25,
  //     to: 29,
  //     factor: {
  //       25: 1,
  //       26: 1,
  //       27: 1,
  //       28: 1,
  //       29: 1,
  //     },
  //     fillOrder: [25, 26, 27, 28, 29, 25, 26, 27, 28, 29, 25, 26, 27, 28, 29],
  //     minProduction: { 1: 6, 2: 12 },
  //   },
  //   child: {
  //     from: 30,
  //     to: 34,
  //     factor: {
  //       30: 1,
  //       31: 1,
  //       32: 1,
  //       33: 1,
  //       34: 1,
  //     },
  //     fillOrder: [
  //       30, 31, 32, 33, 34, 30, 31, 32, 33, 34, 30, 31, 32, 33, 34, 30, 31, 32,
  //       33, 34,
  //     ],
  //     minProduction: { 1: 5, 2: 11 },
  //   },
  //   female: {
  //     from: 35,
  //     to: 40,
  //     factor: {
  //       35: 1,
  //       36: 3,
  //       37: 4,
  //       38: 5,
  //       39: 4,
  //       40: 3,
  //     },
  //     fillOrder: [38, 37, 39, 36, 40, 38, 37, 39, 35, 36, 40],
  //     minProduction: { 1: 12, 2: 18 },
  //   },
  //   male: {
  //     from: 41,
  //     to: 45,
  //     factor: {
  //       41: 3,
  //       42: 3,
  //       43: 2,
  //       44: 1,
  //       45: 1,
  //     },
  //     fillOrder: [41, 42, 43, 44, 45, 41, 42, 43, 44, 45, 41, 42, 43, 41, 42],
  //     minProduction: { 1: 6, 2: 12 },
  //   },
  // };

  const sampleQuantity1 = {
    25: 1,
    26: 1,
    27: 1,
    28: 1,
    29: 1,
    30: 1,
    31: 1,
    32: 1,
    33: 1,
    34: 1,
    35: 1,
    36: 1,
    37: 1,
    38: 1,
    39: 1,
    40: 1,
    41: 1,
    42: 1,
    43: 1,
    44: 1,
    45: 1,
    46: 1,
  }
  const sampleQuantity = {
    25: null,
    26: null,
    27: null,
    28: null,
    29: null,
    30: null,
    31: null,
    32: null,
    33: null,
    34: null,
    35: null,
    36: null,
    37: null,
    38: null,
    39: null,
    40: null,
    41: null,
    42: null,
    43: null,
    44: null,
    45: null,
    46: null,
  }

  const arraySum = (array) => {
    // console.log(array);
    
    const sum = array.reduce((accumulator, currentValue) => {
      return accumulator + currentValue;
    }, 0);
    return sum;
  };

  const getQuantity = async (warehouse) => {
    const res = await axios.post(
      "https://api.hesabfa.com/v1/item/GetQuantity",
      {
        apiKey: "E62BNpYDHmn1K8JFNJG24jDSpTE9ktBP",
        loginToken:
          "3849304732a5e3cfd84a908ffd0b8c1c4e44c804df3692627b127d3f5638d3791105a1df1ddd2f00cb6bf2f36c3d3827",
        warehouseCode: warehouse,
      }
    );
    // console.log(res);
    let filtered = res.data.Result.filter(
      (e) =>
        verifiedCodes.includes(e.Barcode?.substring(0, 2)) &&
        e.Barcode.length === 11
    );

    return filtered;
  };
  const getProduct = async (barcode) => {
    const res = await axios.post(
      "https://api.hesabfa.com/v1/item/getByBarcode",
      {
        apiKey: "E62BNpYDHmn1K8JFNJG24jDSpTE9ktBP",
        loginToken:
          "3849304732a5e3cfd84a908ffd0b8c1c4e44c804df3692627b127d3f5638d3791105a1df1ddd2f00cb6bf2f36c3d3827",
          barcode: barcode
      }
    );
    // console.log(res);
    // let filtered = res.data.Result.filter(
    //   (e) =>
    //     verifiedCodes.includes(e.Barcode?.substring(0, 2)) &&
    //     e.Barcode.length === 11
    // );

    console.log(res);
    
    return res.data.Result.Name;
  };

  const addProductToList = async (products) => {
    console.log("products: ", products);
    console.log("sell long 0: ", sellLong[0]);
    for(let i in products){
      let exist = false
      for(let g in sellLong[0]){
        if(products[i].Barcode.includes(sellLong[0][g].code)){
          exist = true
          break;
        }
      }
      if(!exist){
        const name = await getProduct(products[i].Barcode)
        const code = products[i].Barcode.substring(0,9)
        console.log("code: ", code);
        console.log("code: ", name);
        
        sellLong[0].push({...sampleQuantity1, code: code, title: name})
      }
    }
  }

  const CalculateProduction = (sum, count, i, product, sex, quantityList, sellCount) => {
    // const average = sellCount / count;
    
    // const grade = average > gradeLimit ? 1 : average > 15 ? 2 : 1;
    // const grade = !average ? 1 : average > gradeLimit ? 1 : 2;
    const grade = 1

    let correctBarcode = "";


    let groupQuantity = {};

    // console.log("quantityList: ", quantityList);

    for (let branch of Object.keys(quantityList)) {
      // console.log("branch: ", branch);
      // console.log("group: ", groupQuantity);
      
      groupQuantity[branch] = {...sampleQuantity}
      for (let g = groups[sex].from; g <= groups[sex].to; g++) {
        const code = sellLong[1].filter(
          (e) => e.barcode === product.code + g
        )[0]?.code;

        // calculates needed quantity of this model and size
        const liveQuantity = quantityList[branch].filter((e) => e.Code === code)[0];
        correctBarcode = liveQuantity?.barcode?.substring(0, 9);
        if (liveQuantity) {
          const needQuantity =
            groups[sex].factor[g] * grade - liveQuantity.Quantity;
          groupQuantity[branch][g] = needQuantity <= 0 ? 0 : needQuantity;
        }
      }
      groupQuantity[branch].total = arraySum(Object.values(groupQuantity[branch]))
    }

    // console.log("group quantity: ", groupQuantity);
    const sortedDataArray = Object.entries(groupQuantity).sort(
      ([, a], [, b]) => a.total - b.total
    );

    return groupQuantity
    

    

    // console.log(
    //   i,
    //   "group: ",
    //   sex,
    //   "product: ",
    //   product.title,
    //   "grade: ",
    //   grade,
    //   "groupQuantity: ",
    //   groupQuantity
    // );

    // console.log(totalCount);
  };

  const distrubution = (needByGenderBranch, product) => {
    const genderOrder = {
        heravi: {
            kids: 1,
            child: 1,
            female: 2,
            male: 2,
        },
        dooman: {
            kids: 1,
            child: 1,
            female: 1,
            male: 1,
        },
        merdas: {
            kids: 1,
            child: 1,
            female: 1,
            male: 1,
        },
    }

    let thisProductDistribution = {code: product.code, title: product.title, dist: {}}
    for(let branch of Object.keys(genderOrder)){
      thisProductDistribution.dist[branch] = {...sampleQuantity}
    }

    const addDist = (branch, size, count) => {
      thisProductDistribution.dist[branch][size] = !thisProductDistribution.dist[branch][size] ? count : (thisProductDistribution.dist[branch][size] + count)
    }

    const minusQuantity = (size, gender, branch, count, zeroQ = false, zeroNeed = false) => {
      if(!!zeroQ){
        liveKargahQuantityBySize[size].Quantity = 0
      }else{
        liveKargahQuantityBySize[size].Quantity = liveKargahQuantityBySize[size].Quantity - count
        needByGenderBranch[gender][branch][size] = needByGenderBranch[gender][branch][size] - count
      }
    }

    // console.log("kargah: ", kargah);







    
    // console.log("product: ", product);
    const liveKargahQuantity = kargah.filter(e => e.Barcode.substring(0,9) === product.code)
    let liveKargahQuantityBySize = {}
    liveKargahQuantity.forEach((val) => liveKargahQuantityBySize[val.Barcode.substring(9,11)] = val)
    
    const qqqqqqqqtest = {...liveKargahQuantity}
    console.log("liveKargahQuantityBySize: ", qqqqqqqqtest);

    console.log("need: ", needByGenderBranch);
    

    for(let gender of Object.keys(needByGenderBranch)){
      //gender is each gender. like: kids, child, ...
      
        for(let size = groups[gender].from; size <= groups[gender].to; size++){
          //i is each size.  Example: 41 or 42 or ...

          let needSum = 0
          Object.values(needByGenderBranch[gender]).forEach(e => needSum = needSum + e[size])
          
          while((liveKargahQuantityBySize[size]?.Quantity > 0) && (needSum > 0)){
            
            for(let branch of Object.keys(genderOrder)){
              // branch is each branch. like: heravi, dooman, ...

              if(liveKargahQuantityBySize[size].Barcode === "55001262138"){
                console.log("here is 550012621");
                
              }
              
              if(!!needByGenderBranch[gender][branch][size]){
                if(needByGenderBranch[gender][branch][size] >= genderOrder[branch][gender] ){
                  // need >= max send for branch
                  
                  if(liveKargahQuantityBySize[size].Quantity >= genderOrder[branch][gender]){
                    // quantity >= max send for branch

                    const count = genderOrder[branch][gender]

                    //send max send for branch
                    addDist(branch, size, count)

                    //live quantity - max send for branch
                    minusQuantity(size, gender, branch, count)

                  }else{

                    const count = liveKargahQuantityBySize[size].Quantity

                    //send quantity
                    addDist(branch, size, count)

                    //quantity = 0
                    minusQuantity(size, gender, branch, count, true)
                    break;

                  }
                  
                }else{

                  if(liveKargahQuantityBySize[size].Quantity >= needByGenderBranch[gender][branch][size]){
                    
                    const count = needByGenderBranch[gender][branch][size] ? needByGenderBranch[gender][branch][size] : 1
                    

                    //send as need
                    addDist(branch, size, count)

                    //live quantity - as need
                    minusQuantity(size, gender, branch, count)

                  }else{

                    const count = liveKargahQuantityBySize[size].Quantity

                    //send quantity
                    addDist(branch, size, count)

                    //quantity = 0
                    minusQuantity(size, gender, branch, count, true)
                    break;

                  }

                }
              }
            }
            // sum all needs. terminate if needs where 0
            let nowNeedSum = 0
            Object.values(needByGenderBranch[gender]).forEach(e => nowNeedSum = nowNeedSum + e[size])
            needSum = nowNeedSum
          }
        }
    }
    console.log("product: ", product);
    // console.log("needByGenderBranch: ", needByGenderBranch);
    console.log("jooon jedet kar kon: ", thisProductDistribution);
    console.log("---------------------------------");
    
    for(let i of Object.keys(genderOrder)){
      if(finalData[i]){
        finalData[i].push({code: thisProductDistribution.code, title: thisProductDistribution.title, ...thisProductDistribution.dist[i]})
      }else{
        finalData[i] = [{code: thisProductDistribution.code, title: thisProductDistribution.title, ...thisProductDistribution.dist[i]}]
      }
    }
  } 

  const CalculateDatas = (quantityList) => {
    for (let product of sellLong[0]) {
      let sum = 0;
      let count = 0;
      let sellCount = 0;
      let needByGenderBranch = {kids: {}, child: {}, female: {}, male: {}}
      for (let i = groups.kids.from; i <= groups.male.to; i++) {
        if (!!product[i] && product[i] !== "-") {
          sum = sum + product[i];
          count = count + 1;
          const thisProduct = sellLong[1].find(e => e.barcode === (product.code + i))
          
          // sellCount = sellCount + (product[i] / (thisProduct.sell))
          
        }

        if (groups.kids.to === i) {
          //kids group

          const genderNeed = CalculateProduction(sum, count, i, product, "kids", quantityList, sellCount);
          sum = 0;
          count = 0;
          sellCount = 0;
          const branches = Object.keys(genderNeed)
          for( let i of branches){
            needByGenderBranch["kids"][i] = genderNeed[i]
          }
        }
        if (groups.child.to === i) {
          //child group

          const genderNeed = CalculateProduction(sum, count, i, product, "child", quantityList, sellCount);
          sum = 0;
          count = 0;
          sellCount = 0;
          const branches = Object.keys(genderNeed)
          for( let i of branches){
            needByGenderBranch["child"][i] = genderNeed[i]
          }
        }
        if (groups.female.to === i) {
          //female group

          const genderNeed = CalculateProduction(sum, count, i, product, "female", quantityList, sellCount);

          sum = 0;
          count = 0;
          sellCount = 0;
          const branches = Object.keys(genderNeed)
          for( let i of branches){
            needByGenderBranch["female"][i] = genderNeed[i]
          }
        }
        if (groups.male.to === i) {
          //male group

          const genderNeed = CalculateProduction(sum, count, i, product, "male", quantityList, sellCount);

          sum = 0;
          count = 0;
          sellCount = 0;
          const branches = Object.keys(genderNeed)
          for( let i of branches){
            needByGenderBranch["male"][i] = genderNeed[i]
          }
        }
      }
      // if(product.code === "550015121"){

        console.log("needByGenderBranch: ", product);
        
      // }
      distrubution(needByGenderBranch, product)
      
    }
    
  };

  const startAction = async () => {
    
    // const cleanedData = await SellLongCalculator(
    //   setProccessState,
    //   setProccessText
    // );
    const cleanedData = JSON.parse(localStorage.getItem("sellLong"));

    // localStorage.setItem("sellLong", JSON.stringify(cleanedData));

    sellLong = cleanedData;

    setProccessText("در حال دریافت موجودی فعلی");
    // setProccessText("در حال محاسبه میزان مناسب تولید");
    setProccessState(80);
    // const quantityList = await getQuantity();
    const kargahData = await getQuantity(19);
    kargah = kargahData
    for(let i of kargah){
      if((i.Barcode === "55001262138") || (i.Barcode === "55001262137") || (i.Barcode === "55001262136")){
        console.log("here is 55001262138");
      }
    }
    const heraviQuantity = await getQuantity(11);
    const merdasQuantity = await getQuantity(18);
    const doomanQuantity = await getQuantity(20);
    // const allProducts = await getAllProducts()
    // console.log("quantity List: ", quantityList);
    // localStorage.setItem("quantityList", JSON.stringify(quantityList));

    // const quantityList = JSON.parse(localStorage.getItem("quantityList"));

    // const filledQuantity = addOldQuantitys(quantityList)

    await addProductToList(kargah)

    const filledQuantity = {
      heravi: heraviQuantity,
      merdas: merdasQuantity,
      dooman: doomanQuantity,
    };

    CalculateDatas(filledQuantity);
    // finalData.sort((a, b) => {
    //   if (a.sellLong < 12) return 1;
    //   if (b.sellLong < 12) return -1;
    //   return a.sellLong - b.sellLong;
    // });

    // addQuantityToData(filledQuantity);

    setProccessText("فایل آماده است");
    setProccessState(100);
    for(let i of Object.keys(finalData)){
      exportToCSV(finalData[i], null, i);
    }
    console.log("finalData:", finalData);
    
    // exportToCSV(finalData, sellLong[1], "sells");
  };

  return (
    <div style={{ width: "100%", marginTop: 30 }}>
      <button
        style={{
          backgroundColor: "white",
          border: "solid 1px gray",
          padding: 10,
          borderRadius: 10,
          cursor: "pointer",
          fontSize: 15,
        }}
        onClick={startAction}
      >
        شروع ایجاد فایل
      </button>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          marginTop: 20,
        }}
      >
        <div
          style={{
            width: "80%",
            height: 20,
            backgroundColor: "#dbdbdb",
            borderRadius: 15,
            display: "flex",
            justifyContent: "end",
          }}
        >
          <div
            style={{
              width: `${proccessState}%`,
              height: 20,
              backgroundColor: "#00a600",
              borderRadius: 15,
              transition: "all 2s ease-in-out",
            }}
          ></div>
        </div>
        <p>{proccessText}</p>
      </div>
      {/* <ManyFileInput
        title="فایل اکسل انبار حسابفا"
        fileName="hesabfa"
        contextData={setFileDatas}
      /> */}
    </div>
  );
};

export default DistributionList;
